import type { CheckReportStatusResponse } from '../model/check-report-status-response';

export function isReportGenerated(
  report: CheckReportStatusResponse | undefined
): boolean {
  return report?.status === 'SUCCESS';
}

export function isReportInProgress(
  report: CheckReportStatusResponse | undefined
): boolean {
  return report?.status === 'IN_PROGRESS';
}

export function isReportError(
  report: CheckReportStatusResponse | undefined
): boolean {
  return report?.status === 'ERROR';
}
